import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { FhirContextProvider } from './contexts/FhirContextProvider';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <FhirContextProvider>
      <App />
    </FhirContextProvider>
  </React.StrictMode>
);
